import React, { Fragment, useMemo } from "react";
import { Layout, Menu } from "@cloud/atom-ui";
import useMappedState from "@src/utils/useMappedState";
import { i18n, locale } from "@src/utils/i18n";
import { useDispatch } from "redux-react-hook";
import * as nls from "./nls";
import "./style.m.css";
import Headers from "./headers";
import Customer from "./customer";
import * as actions from "../../actions";
import { APP_TYPE } from '@src/utils/common';
import BottomFooter  from '@src/components/BottomFooter';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;
const I18N = i18n(nls);

export default props => {
  const { siteType } = useMappedState("root");
  const { children, layout, leftSlider: LeftSlider } = props;
  const dispatch = useDispatch();

  const RenderMenu = menu => {
    let href;
    if (window.location.href.indexOf("baseInfo") !== -1 && window.location.href.indexOf("edit") !== -1) {
      let indexNum = window.location.href.indexOf("#");
      let newUrl = window.location.href.substring(indexNum);
      href = newUrl;
    } else {
      href = menu.resUrl;
    }
    if (!menu.isShow) return null;
    if (menu.subResList && menu.subResList.length) {
      // 追加 “0” 防止与子菜单 key 冲突
      return (
        <SubMenu key={menu.key} title={<span>{menu.menuName}</span>}>
          {menu.subResList.map((menu, index) => {
            return RenderMenu(menu, index);
          })}
        </SubMenu>
      );
    }

    return (
      <Menu.Item key={menu.key}>
        <a
          href={href}
          target={menu.open ? "_blank" : "_self"}
          style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          onClick={() => {
            handleDelveFlag(menu.resUrl);
          }}
        >
          {menu.menuName}
        </a>
      </Menu.Item>
    );
  };

  //  传递是否是在编辑页时点击左侧路由
  const handleDelveFlag = href => {
    dispatch(actions.searchFlag(false));
    if (window.location.href.indexOf("baseInfo") !== -1 && window.location.href.indexOf("edit") !== -1) {
      dispatch(actions.changeRouter(href));
      dispatch(actions.routeFlag(true));
    }
  };

  let defaultOpenKeys;

  const subMenu = useMemo(() => {
    const subMenu = [
      {
        //企业内部应用
        menuName: I18N["enterpriseInternalApp"],
        key: APP_TYPE.innerapp,
        resUrl: `#/${APP_TYPE.innerapp}/wecode-v2`,
        isShow: true
      },
      {
        // 第三方应用
        menuName: I18N["thirdPartyApp"],
        key: APP_TYPE.isv,
        resUrl: `#/${APP_TYPE.isv}/wecode-v2`,
        isShow: true
      }
    ];
    return subMenu;
  }, []);

  defaultOpenKeys = ["wecode-v2"];
  let selectedKey = "";
  let type = props.match.params.type;
  selectedKey = type;
  // 地址栏 layout 优先
  let _layout;
  try {
    _layout = props.history.queryParams.query.layout;
  } catch (e) { }
  _layout = _layout || layout;

  const layouts = {
    outer: (
      <Layout style={{ minHeight: "100%" }}>
        <Header className="header">
          <Headers />
        </Header>
        <Content style={{ background: "#FFFFFF", border: "1px solid #DBE6F1", display: "flex" }}>{children}</Content>
        <BottomFooter locale={locale} />
        {(false && siteType && siteType.site_type != 2) && <Customer loginStatus="true" />}
      </Layout>
    ),
    inner: (
      <Layout style={{ minHeight: "100%" }}>
        <Header className="header">
          <Headers />
        </Header>
        <Content
          style={{
            background: "#FFFFFF",
            border: "1px solid #DBE6F1",
            display: "flex"
          }}
        >
          <Layout style={{ background: "#fff", width: "100%" }}>
            {LeftSlider ? (
              <LeftSlider />
            ) : (
              <Sider
                collapsible={false}
                width={200}
                style={{
                  background: "#fff"
                }}
              >
                <div
                  style={{
                    minHeight: "560px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    paddingTop: "15px"
                  }}
                >
                  <Menu
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    defaultOpenKeys={defaultOpenKeys}
                    style={{ height: "100%", width: "calc(100% - 1px)", marginTop: 0 }}
                    className={sessionStorage.getItem("canSeeRoma") ? "layoutMenus" : "noLayoutMenus"}
                  >
                    {subMenu.map((menu, index) => {
                      return RenderMenu(menu, index);
                    })}
                  </Menu>
                  <div style={{ marginBottom: "30px" }}></div>
                </div>
              </Sider>
            )}
            <Content
              style={{
                minHeight: 280,
                margin: "0px",
                overflowX: "inherit",
                width: "calc(100% - 200px)"
              }}
              className={"content"}
            >
              {children}
            </Content>
          </Layout>
        </Content>
        <BottomFooter locale={locale} />
        {(false && siteType && siteType.site_type != 2) && <Customer loginStatus="true" />}
      </Layout>
    ),
    default: <Fragment>{children}</Fragment>
  };
  return layouts[_layout] || layouts.default;
};
